import {
  BaseLayoutSchema,
  CommonInputWidgetConfigSchema,
} from '@framework/engine';
import { yup } from '@framework/validation';
import {
  IMapWidget,
  MapWidgetSelectionShape,
  WidgetTypeMap,
} from './IMapWidget';
import { MapPrintImageSchema } from './config/print/MapPrintImageSchema';
import { MapLayerType } from './layers/MapLayer';
import { MapLayerSchema } from './layers/MapLayerSchema';

export const MapWidgetConfigSchema: yup.ObjectSchema<IMapWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetTypeMap).required(),
    layout: BaseLayoutSchema.shape({}),
    position: yup.object({
      center: yup
        .tuple([yup.number().required(), yup.number().required()])
        .default([11.189417912530622, 44.576276442981985]),
      zoom: yup.number().default(4),
    }),
    layers: yup.array(MapLayerSchema).default([]),
    printImages: yup.array(MapPrintImageSchema).default([]),
    selection: yup.object({
      multiple: yup.boolean().default(true).label('Selezione multipla'),
      shape: yup
        .string()
        .default(MapWidgetSelectionShape.Point)
        .oneOfEnum(MapWidgetSelectionShape)
        .label('Geometrie Selezionabili')
        .required(),
      hideGeometriesTable: yup
        .boolean()
        .default(false)
        .label('Nascondi tabella geometrie'),
    }),
    competence: yup
      .object({
        enabled: yup
          .boolean()
          .default(false)
          .label('Abilita riconoscimento Competenza')
          .parentWhen(['^.selection.shape'], ([shape], schema) => {
            console.log('shape', shape);
            return shape === MapWidgetSelectionShape.Polygon
              ? schema.enabled(true)
              : schema.enabled(false).transform(() => false);
          }),
        type: yup
          .string()
          .label('Tipo')
          .oneOfEnum(MapLayerType)
          .when(['enabled'], ([enabled], schema) =>
            enabled ? schema.required() : schema.strip(),
          ),
        url: yup
          .string()
          .label('URL')
          .when(['enabled'], ([enabled], schema) =>
            enabled ? schema.required() : schema.strip(),
          ),
        propertyName: yup
          .string()
          .label('Nome proprietà per Identificare le Competenze')
          .when(['enabled'], ([enabled], schema) =>
            enabled ? schema.required() : schema.strip(),
          ),
      })
      .addChildrenParentDeps(),
    intersection: yup
      .object({
        enabled: yup
          .boolean()
          .default(false)
          .label('Intersezione')
          .parentWhen(['^.selection.shape'], ([shape], schema) => {
            console.log('shape', shape);
            return shape === MapWidgetSelectionShape.Polygon
              ? schema.enabled(true)
              : schema.enabled(false).transform(() => false);
          }),
        title: yup
          .string()
          .default('Intersezioni')
          .label('Titolo Intersezioni')
          .when(['enabled'], ([enabled], schema) =>
            enabled ? schema.required() : schema.strip(),
          ),
        type: yup
          .string()
          .label('Tipo')
          .oneOfEnum(MapLayerType)
          .when(['enabled'], ([enabled], schema) =>
            enabled ? schema.required() : schema.strip(),
          ),
        url: yup
          .string()
          .label('URL')
          .when(['enabled'], ([enabled], schema) =>
            enabled ? schema.required() : schema.strip(),
          ),
        areaTolerance: yup
          .number()
          .default(0.05)
          .label('Tolleranza (metri quadri minimi)')
          .when(['enabled'], ([enabled], schema) =>
            enabled ? schema.required() : schema.strip(),
          ),
      })
      .addChildrenParentDeps(),
  })
    .required()
    .noUnknown();
